import { accountRepository } from './repository';
import AccountService from './service/AccountServiceImpl';

const accountService = new AccountService(accountRepository);
export { accountService };
